import React, { useState } from "react";
import "./TimeSlotGenerator.css"; // Import CSS for styling

const TimeSlotGenerator = () => {
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [slotDuration, setSlotDuration] = useState("");
    const [breaks, setBreaks] = useState([{ start: "", end: "" }]);
    const [timeSlots, setTimeSlots] = useState([]);

    const handleBreakChange = (index, key, value) => {
        const newBreaks = [...breaks];
        newBreaks[index][key] = value;
        setBreaks(newBreaks);
    };

    const addBreak = () => {
        setBreaks([...breaks, { start: "", end: "" }]);
    };

    const removeBreak = (index) => {
        const newBreaks = [...breaks];
        newBreaks.splice(index, 1);
        setBreaks(newBreaks);
    };

    const generateTimeSlots = () => {
        if (!startTime || !endTime || !slotDuration || !isValidBreaks()) {
            alert("Please enter valid start time, end time, slot duration, and breaks.");
            return;
        }

        const start = new Date(`01/01/2000 ${startTime}`);
        const end = new Date(`01/01/2000 ${endTime}`);

        const slots = [];
        let current = new Date(start);

        while (current <= end) {
            const currentTime = current.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            if (!isDuringBreak(currentTime)) {
                slots.push(currentTime);
            }
            current.setMinutes(current.getMinutes() + parseInt(slotDuration));
        }

        setTimeSlots(slots);
    };

    const isValidBreaks = () => {
        return breaks.every(breakItem => breakItem.start && breakItem.end);
    };

    const isDuringBreak = (time) => {
        return breaks.some(breakItem => time >= breakItem.start && time < breakItem.end);
    };

    return (
        <div className="time-slot-generator">
            <h2>Time Slot Generator</h2>
            <div className="input-group">
                <label>Start Time:</label>
                <input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} />
            </div>
            <div className="input-group">
                <label>End Time:</label>
                <input type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} />
            </div>
            <div className="input-group">
                <label>Slot Duration (minutes):</label>
                <input type="number" value={slotDuration} onChange={(e) => setSlotDuration(e.target.value)} />
            </div>
            <div className="breaks">
                <h3>Breaks:</h3>
                {breaks.map((breakItem, index) => (
                    <div key={index} className="break-item">
                        <label>Break {index + 1} Start:</label>
                        <input type="time" value={breakItem.start} onChange={(e) => handleBreakChange(index, 'start', e.target.value)} />
                        <label>Break {index + 1} End:</label>
                        <input type="time" value={breakItem.end} onChange={(e) => handleBreakChange(index, 'end', e.target.value)} />
                        {index > 0 && <button onClick={() => removeBreak(index)}>Remove Break</button>}
                    </div>
                ))}
                <button onClick={addBreak}>Add Break</button>
            </div>
            <div className="input-group">
                <button onClick={generateTimeSlots}>Generate Time Slots</button>
            </div>
            <div className="time-slots">
                <h3>Available Time Slots:</h3>
                <ul>
                    {timeSlots.map((slot, index) => (
                        <li key={index}>{slot}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default TimeSlotGenerator;
